import lodash from 'lodash';

export default {
  checkObjectKey: (object,path,defaultVal ={}) => {
    return lodash.get(object, path, defaultVal);
  }
}
